import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitRoot } from '@cian/ui-kit';
import * as React from 'react';
import { Provider, useSelector } from 'react-redux';
import '../../assets/colors/colors.css';

import { IApplicationContext } from '../../types/applicationContext';
import { IReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { PageContainer } from '../Page';
import { CookieConsentContainer } from '../CookieConsent';
import { NoSsr } from '@cian/react-utils';
import { EPageType } from '../../types/page';
import { selectPageType } from '../../selectors/page';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IReduxStore;
}

const PageCookieConsent: React.FC = () => {
  const pageType = useSelector(selectPageType);

  return pageType &&
    [
      EPageType.Career,
      EPageType.CareerVacancies,
      EPageType.CareerVacancy,
      EPageType.CareerTeamMarketing,
      EPageType.CareerTeamAnalytics,
      EPageType.CareerTeamTechnologies,
      EPageType.CareerTeamProduct,
      EPageType.CareerTeamBackoffice,
    ].includes(pageType) ? null : (
    <NoSsr>
      <CookieConsentContainer />
    </NoSsr>
  );
};

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <PageContainer />
            <PageCookieConsent />
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
